<video *ngIf="url" controls controlslist="nodownload">
  <source type="video/mp4" src="{{ url }}" />
</video>
